import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Countdown = lazy(() => import('./components/Countdown').then(m => ({
  default: m.Countdown
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const ProBusiness = lazy(() => import('./components/ProBusiness').then(m => ({
  default: m.ProBusiness
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const DarkCTA = lazy(() => import('./components/DarkCTA').then(m => ({
  default: m.DarkCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseNotifications = lazy(() => import('./components/PurchaseNotifications').then(m => ({
  default: m.PurchaseNotifications
})));
// Deferred Facebook Pixel loader
function loadFbPixel() {
  if (typeof window === 'undefined' || (window as any).fbq) return;
  const f = window as any;
  const n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  (window as any).fbq('init', '1215304437119773');
  (window as any).fbq('track', 'PageView');
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(t, s);
}
export function App() {
  useEffect(() => {
    document.title = 'Megapack Anti Pantalla — El Sistema Más Completo de Argentina';
    document.documentElement.lang = 'es';
    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };
    const description = 'El sistema más completo de Argentina para reemplazar las pantallas por aprendizaje real. 6 Tomos + 6 Bonos, +500 páginas de actividades estimulantes listas para imprimir. Acceso inmediato.';
    const url = 'https://antipantalla.construyeprogreso.com';
    const image = 'https://cdn.magicpatterns.com/uploads/v7HbDBttB6KwqMN8KX8fXz/hf_20260408_171512_ee149707-ab8e-4b03-a52c-19e854e7886e_(1)-Photoroom.webp';
    setMeta('description', description);
    setMeta('keywords', 'megapack anti pantalla, actividades para niños, estimulación temprana, fichas imprimibles, juegos educativos, sin pantallas, Argentina, construye progreso');
    setMeta('robots', 'index, follow');
    setMeta('author', 'Construye Progreso™');
    setMeta('viewport', 'width=device-width, initial-scale=1');
    if (!document.querySelector('link[rel="canonical"]')) {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = url;
      document.head.appendChild(canonical);
    }
    setMeta('og:title', 'Megapack Anti Pantalla — El Refuerzo Escolar Más Completo de Argentina', true);
    setMeta('og:description', description, true);
    setMeta('og:image', image, true);
    setMeta('og:url', url, true);
    setMeta('og:type', 'product', true);
    setMeta('og:locale', 'es_AR', true);
    setMeta('og:site_name', 'Construye Progreso™', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Megapack Anti Pantalla — Construye Progreso™');
    setMeta('twitter:description', description);
    setMeta('twitter:image', image);
    if (!document.querySelector('script[data-ld="product"]')) {
      const ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.setAttribute('data-ld', 'product');
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Megapack Anti Pantalla — Sistema Completo 2 a 7 años',
        description: description,
        image: image,
        brand: {
          '@type': 'Brand',
          name: 'Construye Progreso™'
        },
        offers: {
          '@type': 'AggregateOffer',
          lowPrice: '19990',
          highPrice: '49990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          offerCount: 2
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '1243'
        }
      });
      document.head.appendChild(ld);
    }
    if (!document.querySelector('script[data-ld="org"]')) {
      const orgLd = document.createElement('script');
      orgLd.type = 'application/ld+json';
      orgLd.setAttribute('data-ld', 'org');
      orgLd.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Construye Progreso™',
        url: url,
        logo: image,
        email: 'construyeprogresoo@gmail.com',
        sameAs: ['https://www.instagram.com/construyeprogresoo']
      });
      document.head.appendChild(orgLd);
    }
    if (!document.querySelector('script[data-ld="faq"]')) {
      const faqLd = document.createElement('script');
      faqLd.type = 'application/ld+json';
      faqLd.setAttribute('data-ld', 'faq');
      faqLd.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [{
          '@type': 'Question',
          name: '¿Qué incluye el Megapack Anti Pantalla?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '6 Tomos completos para niños de 2 a 7 años, +500 páginas de actividades estimulantes, fichas imprimibles de lectoescritura, números, lógica e inglés inicial, más 6 bonos exclusivos.'
          }
        }, {
          '@type': 'Question',
          name: '¿Cómo recibo el material?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Todo es 100% digital en formato PDF. Recibís acceso inmediato en tu email dentro de los 5 minutos posteriores a la compra.'
          }
        }, {
          '@type': 'Question',
          name: '¿Tiene garantía?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí, ofrecemos garantía de 7 días sin preguntas. Si no te sirve, te devolvemos el 100% de tu dinero.'
          }
        }, {
          '@type': 'Question',
          name: '¿Para qué edad es el Megapack?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'El Megapack Anti Pantalla está diseñado para niños de 2 a 7 años. Cada tomo está organizado por nivel de dificultad para que el niño avance a su propio ritmo.'
          }
        }]
      });
      document.head.appendChild(faqLd);
    }
  }, []);
  // Defer FB pixel until after initial paint
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadFbPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadFbPixel, 2000);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1215304437119773&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>

      <header className="relative flex w-full flex-col items-center justify-center text-center text-gray-900 text-base leading-6 px-4 sm:px-5 py-8 sm:py-12" role="banner" style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      backgroundImage: 'linear-gradient(135deg, rgb(255,247,237) 0%, rgb(255,237,213) 30%, rgb(255,247,237) 60%, rgb(248,250,252) 100%)',
      backgroundColor: 'rgb(255, 255, 255)'
    }} data-id="element-2">
        {/* MARCA */}
        <div className="mb-2" data-id="element-3">
          <span className="text-xl sm:text-2xl font-black tracking-[2.4px] text-orange-500" data-id="element-4">
            🧒 CONSTRUYE PROGRESO™
          </span>
        </div>

        {/* BADGE DE URGENCIA */}
        <div className="mb-3 bg-red-600 text-white text-xs sm:text-sm font-black px-4 py-1.5 rounded-full animate-pulse" data-id="element-5">
          🔥 OFERTA POR TIEMPO LIMITADO — 60% OFF HOY
        </div>

        {/* HEADLINE PRINCIPAL */}
        <h1 className="text-[36px] leading-[42px] sm:text-5xl sm:leading-tight md:text-[72px] md:leading-[80px] font-black max-w-4xl text-gray-900 m-0 mb-4" data-id="element-6">
          ¿Tu hijo no suelta
          <br data-id="element-7" />
          el celular?
          <br data-id="element-8" />
          <span className="text-orange-500" data-id="element-9">Resolvelo hoy.</span>
        </h1>

        {/* IMAGEN DEL PRODUCTO — LCP element */}
        <div className="my-6 w-full max-w-[360px] sm:max-w-[400px] aspect-square relative" style={{
        perspective: '800px'
      }} data-id="element-10">
          <div className="absolute inset-4 rounded-full blur-3xl opacity-40 -z-10" style={{
          backgroundColor: 'rgb(249, 115, 22)'
        }} data-id="element-11" />
          <img src="https://cdn.magicpatterns.com/uploads/qjMZ9B74wu1wrmtYGYNm8K/hf_20260414_012954_115573b9-1bb3-4273-9ad0-c15d1fe6219c-Photoroom.webp" alt="Megapack Anti Pantalla — Sistema Completo 2 a 7 años — Construye Progreso" width="400" height="400" fetchPriority="high" decoding="sync" className="block max-w-full w-full h-auto object-contain relative z-10 drop-shadow-2xl" style={{
          transform: 'rotateY(-4deg) rotateX(2deg)',
          transformStyle: 'preserve-3d'
        }} data-id="element-12" />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-6 rounded-full blur-xl opacity-20" style={{
          backgroundColor: 'rgb(0, 0, 0)'
        }} data-id="element-13" />
        </div>

        {/* PROMESA EMOCIONAL */}
        <p className="max-w-3xl text-lg sm:text-xl font-bold text-orange-500 m-0 mb-3" data-id="element-14">
          "Más de 500 páginas de juegos que atrapan su atención y estimulan su
          cerebro. Listo para imprimir hoy."
        </p>

        {/* TAGS DE CONFIANZA */}
        <div className="mb-5 flex max-w-none flex-wrap items-center justify-center gap-2" data-id="element-15">
          {['📄 100% PDF Imprimible', '⚡ Acceso Inmediato', '🇦🇷 Hecho en Argentina', '👶 2 a 7 años', '✅ Sin Pantallas', '🧠 Estimulación Real', '✂️ Listo para Imprimir', '🎯 Lectoescritura + Inglés'].map(tag => <span key={tag} className="whitespace-nowrap bg-white/80 text-xs sm:text-sm font-semibold text-gray-900 leading-5 border border-orange-400/40 rounded-full px-3 py-1" data-id="element-16">
              {tag}
            </span>)}
        </div>

        {/* PRECIO TACHADO */}
        <div className="mb-3 flex flex-col items-center gap-1" data-id="element-17">
          <span className="text-sm text-gray-400 line-through font-medium" data-id="element-18">
            Precio normal: $49.990
          </span>
          <span className="text-3xl sm:text-4xl font-black text-gray-900" data-id="element-19">
            Hoy solo <span className="text-orange-500" data-id="element-20">$19.990</span>
          </span>
          <span className="text-sm font-bold text-green-600 bg-green-100 px-3 py-1 rounded-full" data-id="element-21">
            🎉 Ahorrás $30.000 — 60% OFF
          </span>
        </div>

        {/* CTA PRINCIPAL */}
        <a href="#pricing" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Hero CTA Click',
            content_category: 'Anti Pantalla'
          });
        }
      }} className="block w-full max-w-sm bg-orange-500 hover:bg-orange-600 text-white sm:text-xl font-black rounded-xl px-6 sm:px-8 py-4 mb-4 no-underline transition-colors text-center shadow-lg text-[20px]" data-id="element-22">
          🛒 QUIERO EL MEGAPACK AHORA
        </a>

        {/* GARANTÍAS */}
        <p className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm text-gray-500 m-0" data-id="element-23">
          <span data-id="element-24">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-25">🔒 Pago 100% seguro</span>
          <span data-id="element-26">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </p>
      </header>

      <main data-id="element-27">
        <SocialProof data-id="element-28" />
        <PainPoints data-id="element-29" />
        <ProductShowcase data-id="element-30" />

        <Suspense fallback={null} data-id="element-31">
          <WhatYouGet data-id="element-32" />
          <Bonuses data-id="element-33" />
          <Countdown data-id="element-34" />
          <Pricing data-id="element-35" />
          <ProBusiness data-id="element-36" />
          <Guarantee data-id="element-37" />
          <Testimonials data-id="element-38" />
          <FAQ data-id="element-39" />
          <DarkCTA data-id="element-40" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-41">
        <Footer data-id="element-42" />
        <PurchaseNotifications data-id="element-43" />
      </Suspense>
    </>;
}